"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M19.14,16.65a.7.7,0,1,0-.67-.51l-1.24.72a.7.7,0,0,0-1.18.32H14.8a.7.7,0,1,0-1.35.38l-1.69,1.11V15.86l2.15-1.3A.7.7,0,0,0,15,14.43l1.39.45a.7.7,0,1,0,1.26-.41l1.2-1.52a.69.69,0,1,0-.27-.23l-1.21,1.53a.7.7,0,0,0-.88.29l-1.38-.44a.7.7,0,1,0-1.37.16l-2,1.19V11.9a.18.18,0,1,0-.35,0v7.91a.18.18,0,0,0,.18.18H19.5a.18.18,0,0,0,0-.35H11.76v-.55l1.87-1.23a.7.7,0,0,0,1.17-.33H16a.7.7,0,1,0,1.35-.36l1.24-.73A.7.7,0,0,0,19.14,16.65Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M11.58,11.72a.18.18,0,0,1,.18.18v7.74H19.5a.18.18,0,1,1,0,.35H11.58a.18.18,0,0,1-.18-.18V11.9a.18.18,0,0,1,.18-.18m0-.25a.43.43,0,0,0-.43.43v7.91a.43.43,0,0,0,.43.43H19.5a.43.43,0,1,0,0-.85H12V11.9a.43.43,0,0,0-.43-.43Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#004864",
    d: "M11.42,20.62a.67.67,0,0,1-.67-.67V15.54a3.9,3.9,0,0,0-.36-.27V3.75a2.17,2.17,0,0,0-4.34,0V15.27a3.9,3.9,0,1,0,5.45,5.36Zm-3.2-.81a1.3,1.3,0,0,1-.43-2.52V8.09a.43.43,0,0,1,.87,0v9.2a1.3,1.3,0,0,1-.43,2.52Z"
  })));
};

exports["default"] = _default;